import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../redux/store";
import { determineIsSizeChart } from "../../../util/add-to-cart";
import { selectProductSizeChart } from "../selectors";

const SizeChart: FC<{
  setShowProductSizeChart: (isSizeChart: boolean) => void;
}> = ({ setShowProductSizeChart }) => {
  const { t } = useTranslation("productDetails");
  const sizeChart = useAppSelector(selectProductSizeChart);
  const isSizeChart = determineIsSizeChart(sizeChart);

  return (
    !!isSizeChart && (
      <div className="sizeChart">
        <div className="title" onClick={() => setShowProductSizeChart(true)}>
          <h5>{t("sizeGuide")}</h5>
        </div>
      </div>
    )
  );
};

export default memo(SizeChart);
